import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';

export type SparkJsVersionData = {
  version: string;
  created_at: string;
  updated_at?: string;
};

export type SparkJsVersionsResponse = {
  versions: SparkJsVersionData[];
};

export interface SparkJsApiContract {
  versions(): Promise<SparkJsVersionsResponse>;
  updateVersion(siteId: string, siteEnv: string, version: string): Promise<void>;
}

declare module '@sparklayer-io/spark-dash-core/context/page-context' {
  interface Apis {
    sparkJs: SparkJsApiContract;
  }
}

export class SparkJsApi extends ApiService implements SparkJsApiContract {
  public versions(): Promise<SparkJsVersionsResponse> {
    return this.api.fetch<SparkJsVersionsResponse>({
      method: 'GET',
      path: '/sparkjs-versions',
    });
  }

  public updateVersion(siteId: string, siteEnv: string, version: string): Promise<void> {
    return this.api.fetch<void>({
      method: 'POST',
      path: `/${encodeURIComponent(siteId)}/${encodeURIComponent(siteEnv)}/sparkjs-version`,
      payload: { sparkjs_version: version },
    });
  }
}
